import React from 'react';

const ENDPOINTS = [
  ['Replay', 'Any moment'],
  ['Simulate', 'What-if'],
  ['API', 'GraphQL / SQL'],
  ['Share', 'Video briefs'],
];

export function DeployLayer() {
  return (
    <section id="deploy" className="scroll-mt-24">
      <div className="flex items-center gap-4 mb-5">
        <span className="font-mono text-sm text-white border border-white/20 rounded-lg px-2.5 py-2.5 bg-white/5 shrink-0">04</span>
        <div>
          <h3 className="text-base font-bold text-white">Deploy</h3>
          <p className="text-sm text-white/40">The fourth dimension: Time</p>
        </div>
      </div>

      {/* time scrubber */}
      <div className="relative h-14 mt-1" aria-hidden="true">
        <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-white/10 rounded" />
        <div className="absolute top-1/2 h-0.5 rounded bg-gradient-to-r from-transparent to-white animate-[scrub_4s_ease-in-out_infinite]" />
        <div className="absolute top-1/2 w-3 h-3 rounded-full bg-white -translate-x-1/2 -translate-y-1/2 shadow-[0_0_0_5px_rgba(255,255,255,.12)] animate-[headmove_4s_ease-in-out_infinite]" />
        <div className="absolute top-1 font-mono text-[10px] tracking-widest uppercase text-white bg-white/10 border border-white/10 rounded px-2 py-0.5 animate-[badge_4s_ease-in-out_infinite]">
          T − 14:00 · replaying
        </div>
        <div className="absolute left-0 right-0 bottom-0 flex justify-between">
          {['06:00', '09:00', '12:00', '15:00', '18:00'].map((t) => (
            <span key={t} className="font-mono text-[9px] tracking-wider text-white/30">{t}</span>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-4">
        {ENDPOINTS.map(([name, sub], i) => (
          <div key={name} className="border border-white/10 rounded-lg bg-white/[0.03] px-2.5 py-2.5 text-center">
            <b className="block text-sm font-bold text-white">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400 mr-1.5 animate-[blink_1.6s_ease-in-out_infinite]"
                    style={{ animationDelay: `${i * 0.4}s` }} />
              {name}
            </b>
            <small className="font-mono text-[9px] tracking-widest uppercase text-white/30">{sub}</small>
          </div>
        ))}
      </div>
    </section>
  );
}
